const { tns } = require('../../../node_modules/tiny-slider/src/tiny-slider');

if (document.querySelector('.js-news-related')) {
    document.querySelectorAll('.js-news-related').forEach((slider) => {
        tns({
            container: slider,
            slideBy: 1,
            speed: 500,
            autoplay: false,
            center: false,
            mouseDrag: true,
            nav: false,
            autoplayButtonOutput: false,
            loop: false,
            items: 1,
            controlsText: ['\uf053', '\uf054'],
            gutter: 20,

            responsive: {
                [window.cssBreakpoints.desk]: {
                    items: 5,
                },
            },

        });
    });
}
